import axios from 'axios';
import { GET_PROSPECTS, GET_SPECIFIC_PROSPECT, ADD_PROSPECT, EDIT_PROSPECT, DELETE_PROSPECT, CLEAR_PROSPECTS, PROSPECTS_LOADING } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IProspect } from '../../types/interfaces';
import store from '../store';

export const getProspects = () => (dispatch: Function, getState: Function) => {
  // dispatch(setProspectsLoading());
  dispatch({
    type: PROSPECTS_LOADING
  });
  axios
    .get('/api/prospects', {...tokenConfig(getState), params: {}})
    .then(res =>
      dispatch({
        type: GET_PROSPECTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getProspectById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: PROSPECTS_LOADING
  });
  axios
    .get('/api/prospects/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_PROSPECT,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const addProspect = (prospect: IProspect, interests: any[], callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/prospects', {prospect, interests}, tokenConfig(getState))
    .then(res =>{
      dispatch({
        type: ADD_PROSPECT,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editProspect = (prospect: IProspect, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/prospects/edit', {prospect}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_PROSPECT,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteProspect = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/prospects/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_PROSPECT,
        payload: id
      })
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const clearProspects = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_PROSPECTS
  })
};